export default __webpack_public_path__ + "static/1-f99f4d6a3b0b39c1006ec35e7947e508.jpg";